export const MICROSITE_PATH = {
  INDEX: '/microsite/onboarding/',
  EDIT: '/microsite-admin/'
}

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/jpg'
]

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_SIZE = 5 * 1024 * 1024 // 5MB
